export const styles = {
  subscriptionContainer: {
    padding: '20px',
  } as React.CSSProperties,
  pageTitle: {
    fontSize: '22px',
    marginBottom: '20px',
  } as React.CSSProperties,

  subscriptionCard: {
    background: 'white',
    border: '1px solid #ddd',
    marginBottom: '24px',
  } as React.CSSProperties,

  statusActive: {
    background: '#38b000',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '3px',
    fontWeight: 500,
    display: 'inline-block',
    minWidth: '60px',
    textAlign: 'center' as const,
  } as React.CSSProperties,

  statusExpired: {
    background: '#dc3545',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '3px',
    fontWeight: 500,
    display: 'inline-block',
    minWidth: '60px',
    textAlign: 'center' as const,
  } as React.CSSProperties,

  statusBlocked: {
    background: '#ff8c00',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '3px',
    fontWeight: 500,
    display: 'inline-block',
    minWidth: '60px',
    textAlign: 'center' as const,
  } as React.CSSProperties,

  buyBtn: {
    background: '#1e73be',
    color: 'white',
    border: 'none',
    padding: '6px 16px',
    borderRadius: '16px',
    cursor: 'pointer',
    minWidth: '80px',
    height: '32px',
    fontSize: '14px',
    fontWeight: '500',
  } as React.CSSProperties,

  contactBtn: {
    background: '#ff8c00',
    color: 'white',
    border: 'none',
    padding: '6px 16px',
    borderRadius: '16px',
    cursor: 'pointer',
    minWidth: '100px',
    height: '32px',
    fontSize: '14px',
    fontWeight: '500',
  } as React.CSSProperties,

  actionCell: {
    display: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,

  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100px',
    justifyContent: 'flex-start',
  } as React.CSSProperties,

  toggleWrapper: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '32px',
    width: '100%',
  } as React.CSSProperties,

  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '32px',
    width: '100%',
  } as React.CSSProperties,

  expandArrow: {
    cursor: 'pointer',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
  } as React.CSSProperties,

  nestedContent: {
    display: 'flex',
    flexDirection: 'row' as const,
    gap: '40px',
    padding: '10px',
  } as React.CSSProperties,

  subscriptionDetail: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start' as const,
    minWidth: '120px',
  } as React.CSSProperties,

  subscriptionNameLink: {
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    padding: '0',
  } as React.CSSProperties,

  subscriptionGroupTitle: {
    marginBottom: '16px',
    fontSize: '18px',
    fontWeight: 600,
  } as React.CSSProperties,

  retryButton: {
    background: '#1e73be',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '10px',
  } as React.CSSProperties,

  errorMessage: {
    textAlign: 'center' as const,
    padding: '20px',
    background: '#ffe6e6',
    border: '1px solid #ffcccc',
    borderRadius: '4px',
    margin: '20px 0',
    color: '#d00',
  } as React.CSSProperties,

  detailLabel: {
    fontWeight: 'bold' as const,
  } as React.CSSProperties,

  detailValue: {
    marginTop: '4px',
  } as React.CSSProperties,
}
